import React from "react";
import PropTypes from "prop-types";
import Button from "Components/button/Button";
import t from "Utils/translation";
import cx from "classnames";
import TranslatedString from "Components/TranslatedString";
import Congratulations from "Components/congratulations/Congratulations";
import { creationArchive } from "Icons/index";

const ContextTypes = {
  router: PropTypes.object
};

class CongratulationsScreen extends React.Component {
  constructor(props) {
    super(props);
    this.returnToList = this.returnToList.bind(this);
    this.state = {};
  }

  returnToList() {
    if (this.props.isAddingDomain) {
      this.props.history.push("/archive");
    } else {
      this.props.history.push(
        `/archive/domains/${this.props.match.params.domainCode}/email_accounts`
      );
    }
  }

  render() {
    return (
      <Congratulations
        title={t("archive.add.title.step5")}
        body={<TranslatedString>archive.add.desc.step5</TranslatedString>}
        illustration={creationArchive}
        buttonText={`button.goToArchive`}
        buttonAction={this.returnToList}
      />
    );
  }
}

CongratulationsScreen.contextTypes = ContextTypes;

export default CongratulationsScreen;
